

!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="ffcc60ab-30ef-5954-8081-cc17d7473dbd")}catch(e){}}();
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired8fd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired8fd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bTOsk", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $8a9bf83c7c97c83b$export$2bf9932c19d6a5d2, (v) => $8a9bf83c7c97c83b$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "shardUrlUnchecked", () => $8a9bf83c7c97c83b$export$1d37a31d51d1e3ed, (v) => $8a9bf83c7c97c83b$export$1d37a31d51d1e3ed = v);
$parcel$export(module.exports, "getDomainShardIndex", () => $8a9bf83c7c97c83b$export$b4cd98d62f81485f, (v) => $8a9bf83c7c97c83b$export$b4cd98d62f81485f = v);
$parcel$export(module.exports, "applyShardToDomain", () => $8a9bf83c7c97c83b$export$108ff8fc702e621f, (v) => $8a9bf83c7c97c83b$export$108ff8fc702e621f = v);
$parcel$export(module.exports, "domainShardingKey", () => $8a9bf83c7c97c83b$export$f6f4188f9108e61, (v) => $8a9bf83c7c97c83b$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $8a9bf83c7c97c83b$export$2bf9932c19d6a5d2;
var $8a9bf83c7c97c83b$export$1d37a31d51d1e3ed;
var $8a9bf83c7c97c83b$export$b4cd98d62f81485f;
var $8a9bf83c7c97c83b$export$108ff8fc702e621f;
var $8a9bf83c7c97c83b$export$f6f4188f9108e61;
let $8a9bf83c7c97c83b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $8a9bf83c7c97c83b$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $8a9bf83c7c97c83b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $8a9bf83c7c97c83b$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $8a9bf83c7c97c83b$var$removeTrailingShard(subdomain) {
    if (!$8a9bf83c7c97c83b$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $8a9bf83c7c97c83b$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8a9bf83c7c97c83b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $8a9bf83c7c97c83b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $8a9bf83c7c97c83b$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $8a9bf83c7c97c83b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $8a9bf83c7c97c83b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8a9bf83c7c97c83b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $8a9bf83c7c97c83b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8a9bf83c7c97c83b$var$globalKeyName]) return url;
    return $8a9bf83c7c97c83b$var$shardUrlUnchecked(url, maxShards);
}
$8a9bf83c7c97c83b$export$2bf9932c19d6a5d2 = $8a9bf83c7c97c83b$var$shardUrl;
$8a9bf83c7c97c83b$export$1d37a31d51d1e3ed = $8a9bf83c7c97c83b$var$shardUrlUnchecked;
$8a9bf83c7c97c83b$export$b4cd98d62f81485f = $8a9bf83c7c97c83b$var$getDomainShardIndex;
$8a9bf83c7c97c83b$export$108ff8fc702e621f = $8a9bf83c7c97c83b$var$applyShardToDomain;
$8a9bf83c7c97c83b$export$f6f4188f9108e61 = $8a9bf83c7c97c83b$var$globalKeyName;

});


//# sourceMappingURL=index.js.map

//# debugId=ffcc60ab-30ef-5954-8081-cc17d7473dbd
